// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__1xRhP","accent":"Badge_accent__11c0I","neutral":"Badge_neutral__6EHdh"};